export const BannerDetails = {
  LENDING_TREE: { logoClassName: 'lending-tree-logo ml-1',
    partnerMessage: 'In partnership with' },
  CREDIT_KARMA: { logoClassName: 'credit-karma-logo ml-1',
    partnerMessage: 'For members of' }
};
